<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 17 10`"
    :width="getWidth"
  >
    <path d="M16.703125,8.70588476 C16.703125,8.89596258 16.6751728,9.06926623 16.6192676,9.2258009 C16.5633623,9.38233558 16.4627344,9.52768703 16.3173808,9.6618596 C16.0825788,9.90784267 15.7778998,10.0308324 15.4033346,10.0308324 C15.0287695,10.0308324 14.6961383,9.90784267 14.4054311,9.6618596 L8.68635351,3.94278204 L2.96727594,9.6618596 C2.72129288,9.90784267 2.41102345,10.0308324 2.03645833,10.0308324 C1.66189322,10.0308324 1.33485246,9.90784267 1.05532626,9.6618596 C0.820524245,9.42705759 0.703125,9.1223786 0.703125,8.74781348 C0.703125,8.37324837 0.820524245,8.04620761 1.05532626,7.76668141 L7.73037867,1.07485751 C7.96518068,0.840055495 8.26985968,0.72265625 8.64442479,0.72265625 C9.01898991,0.72265625 9.3516211,0.840055495 9.64232835,1.07485751 L16.3173808,7.76668141 C16.4627344,7.90085399 16.5633623,8.04341021 16.6192676,8.19435436 C16.6751728,8.34529851 16.703125,8.51580694 16.703125,8.70588476 Z" />
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-caret-up'

  export default {
    name: 'SvgIconCaretUp',
    components: {},
    mixins: [ bem ],
    props: {
      height: {
        default: '10',
        type: String
      },
      width: {
        default: '17',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconCaretUp.vue